import { useLocation, useSearchParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetTrigger } from "@/components/ui/sheet";

interface CustomSheetProps {
  trigger: React.ReactNode;
  title: string;
  children: React.ReactNode;
  className?: string;
  side?: "top" | "right" | "bottom" | "left";
}

export const CustomSheet = ({ trigger, title, children, className, side = "right" }: CustomSheetProps) => {
  const [open, setOpen] = useState<boolean>(false);
  const pathname = useLocation().pathname;
  const [searchParams] = useSearchParams();

  useEffect(() => {
    setOpen(false);
  }, [pathname, searchParams]); // Watch both pathname and search params changes

  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetTrigger asChild>{trigger}</SheetTrigger>
      <SheetContent
        side={side}
        className={className}
        onOpenAutoFocus={(e: Event) => {
          e.preventDefault();
        }}
      >
        <SheetHeader>
          <SheetTitle>{title}</SheetTitle>
        </SheetHeader>
        {children}
      </SheetContent>
    </Sheet>
  );
};
